import React from 'react'
import "./category.css"

export default function Category () {
    return(
        <div id="category" className="p-5 m-5">
        
       
    <div class="container">
      <div class="row pt-4">

        <div class=" col-lg-4 col-sm-6">
          <div class="box mb-3 m-2 m-2">
            <a href="#">
              <img src="https://images.pexels.com/photos/8287257/pexels-photo-8287257.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" alt=""/>
              <div class="box__title">
                <h6>Home Cleaning</h6>
                <p>6 Listings</p>
              </div>
            </a>
          </div>
        </div>
        
        <div class=" col-lg-4 col-sm-6">
          <div class="box mb-3 m-2">
            <a href="#">
              <img src="https://images.pexels.com/photos/2348359/pexels-photo-2348359.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500" alt=""/>
              <div class="box__title">
                <h6>Trucking</h6>
                <p>3 Listings</p>
              </div>
            </a>
          </div>
        </div>

        <div class=" col-lg-4 col-sm-6">
          <div class="box mb-3 m-2">
            <a href="#">
              <img src="https://images.pexels.com/photos/1094767/pexels-photo-1094767.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" alt=""/>
              <div class="box__title">
                <h6>Handyman</h6>
                <p>2 Listings</p>
              </div>
            </a>
          </div>
        </div>
        
        <div class=" col-lg-4 col-sm-6">
          <div class="box mb-3 m-2">
            <a href="#">
              <img src="https://images.pexels.com/photos/733205/pexels-photo-733205.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500" alt=""/>
              <div class="box__title">
                <h6>Landscaper</h6>
                <p>7 Listings</p>
              </div>
            </a>
          </div>
        </div>

        <div class=" col-lg-4 col-sm-6">
          <div class="box mb-3 m-2">
            <a href="#">
              <img src="https://images.pexels.com/photos/3811074/pexels-photo-3811074.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" alt=""/>
              <div class="box__title">
                <h6>ASAP</h6>
                <p>1 Listings</p>
              </div>
            </a>
          </div>
        </div>

        <div class=" col-lg-4 col-sm-6">
          <div class="box mb-3 m-2">
            <a href="#">
              <img src="https://images.pexels.com/photos/57690/pexels-photo-57690.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" alt=""/>
              <div class="box__title">
                <h6>Lifestyle</h6>
                <p>8 Listings</p>
              </div>
            </a>
          </div>
        </div>

        <div class=" col-lg-4 col-sm-6">
          <div class="box mb-3 m-2">
            <a href="#">
              <img src="https://images.pexels.com/photos/1601773/pexels-photo-1601773.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500" alt=""/>
              <div class="box__title">
                <h6>Graphic/design</h6>
                <p>12 Listings</p>
              </div>
            </a>
          </div>
        </div>

        
        <div class=" col-lg-4 col-sm-6">
          <div class="box mb-3 m-2">
            <a href="#">
              <img src="https://images.pexels.com/photos/2292919/pexels-photo-2292919.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500" alt=""/>
              <div class="box__title">
                <h6>Section</h6>
                <p>6 Listings</p>
              </div>
            </a>
          </div>
        </div>
        
        <div class=" col-lg-4 col-sm-6">
          <div class="box mb-3 m-2">
            <a href="#">
              <img src="https://images.pexels.com/photos/9486569/pexels-photo-9486569.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500" alt=""/>
              <div class="box__title">
                <h6>Sitter</h6>
                <p>3 Listings</p>
              </div>
            </a>
          </div>
        </div>

        <div class=" col-lg-4 col-sm-6">
          <div class="box mb-3 m-2">
            <a href="#">
              <img src="https://images.pexels.com/photos/96380/pexels-photo-96380.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2" alt=""/>
              <div class="box__title">
                <h6>Music</h6>
                <p>2 Listings</p>
              </div>
            </a>
          </div>
        </div>
        
        <div class=" col-lg-4 col-sm-6">
          <div class="box mb-3 m-2">
            <a href="#">
              <img src="https://picsum.photos/id/3/200/300" alt=""/>
              <div class="box__title">
                <h6>Run Errand</h6>
                <p>7 Listings</p>
              </div>
            </a>
          </div>
        </div>

        <div class=" col-lg-4 col-sm-6">
          <div class="box mb-3 m-2">
            <a href="#">
              <img src="https://images.pexels.com/photos/587741/pexels-photo-587741.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500" alt=""/>
              <div class="box__title">
                <h6>Catering</h6>
                <p>1 Listings</p>
              </div>
            </a>
          </div>
        </div>

        <div class=" col-lg-4 col-sm-6">
          <div class="box mb-3 m-2">
            <a href="#">
              <img src="https://images.pexels.com/photos/13861/IMG_3496bfree.jpg?auto=compress&cs=tinysrgb&dpr=2&w=500" alt=""/>
              <div class="box__title">
                <h6>Transport</h6>
                <p>8 photos</p>
              </div>
            </a>
          </div>
        </div>

        <div class=" col-lg-4 col-sm-6">
          <div class="box mb-3 m-2">
            <a href="#">
              <img src="https://images.pexels.com/photos/2774556/pexels-photo-2774556.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500" alt=""/>
              <div class="box__title">
                <h6>Event Planning</h6>
                <p>12 Listings</p>
              </div>
            </a>
          </div>
        </div>

       
        <div class=" col-lg-4 col-sm-6">
          <div class="box mb-3 m-2">
            <a href="#">
              <img src="https://images.pexels.com/photos/1119152/pexels-photo-1119152.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500" alt=""/>
              <div class="box__title">
                <h6>Security</h6>
                <p>6 Listings</p>
              </div>
            </a>
          </div>
        </div>
        
      </div>

    </div>
            </div>
                
    )
}